import { render } from "./GrantCriteriaDetails.vue?vue&type=template&id=e1f700c4&scoped=true&ts=true"
import script from "./GrantCriteriaDetails.vue?vue&type=script&lang=ts"
export * from "./GrantCriteriaDetails.vue?vue&type=script&lang=ts"

import "./GrantCriteriaDetails.vue?vue&type=style&index=0&id=e1f700c4&lang=scss&scoped=true"

import exportComponent from "../../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-e1f700c4"]])

export default __exports__